<template>
    <div class="counselor-filter mb-3">
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/3">
                <label class="text-sm font-medium mb-2 block">상담 담당자 필터</label>
                <vs-select
                    :value="selectedCounselor"
                    placeholder="상담 담당자 선택"
                    @input="handleCounselorChange"
                    class="w-full"
                >
                    <vs-select-item 
                        :key="'none'" 
                        :value="'none'" 
                        :text="'선택하세요'"
                    />
                    <vs-select-item 
                        :key="'all'" 
                        :value="'all'" 
                        :text="'전체'"
                    />
                    <vs-select-item 
                        :key="'unassigned'" 
                        :value="'unassigned'" 
                        :text="'미지정'"
                    />
                    <vs-select-item
                        v-for="counselor in hardCodedCounselors"
                        :key="counselor"
                        :value="counselor"
                        :text="counselor"
                    />
                </vs-select>
            </div>
            <div class="vx-col w-full md:w-2/3 text-right">
                <span class="text-sm text-gray-600">
                    선택된 담당자: {{ selectedCounselorName }}
                    <span v-if="filteredCount > 0"> | 표시 건수: {{ filteredCount }}건</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CounselorFilter',
    props: {
        filteredCount: {
            type: Number,
            default: 0
        },
        value: {
            type: String,
            default: 'none'
        }
    },
    data() {
        return {
            selectedCounselor: this.value,
            // 하드코딩된 상담 담당자 목록 (빠른 로딩을 위해)
            hardCodedCounselors: [
                '노경호',
                '박유미', 
                '신모정',
                '신지은',
                '정유리'
            ]
        };
    },
    computed: {
        selectedCounselorName() {
            if (this.selectedCounselor === 'none') {
                return '선택하세요';
            } else if (this.selectedCounselor === 'all') {
                return '전체';
            } else if (this.selectedCounselor === 'unassigned') {
                return '미지정';
            }
            return this.selectedCounselor;
        }
    },
    watch: {
        value(newVal) {
            this.selectedCounselor = newVal;
        }
    },
    methods: {
        handleCounselorChange(counselor) {
            this.selectedCounselor = counselor;
            this.$emit('counselor-change', counselor);
        }
    }
};
</script>

<style scoped>
.counselor-filter {
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 0.5rem;
    border: 1px solid #e9ecef;
}

.text-gray-600 {
    color: #6c757d;
}
</style>